<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <card-header :title="title" :icon="icon"></card-header>
          <v-card-text>
            <v-data-table v-model="selectedItems" :headers="columns" :items="localTableData" item-key="idx" show-select
              disable-pagination hide-default-footer class="elevation-0" @input="updateSelected">
            </v-data-table>
          </v-card-text>

          <v-card-text>
            <slot name="bottom-content"></slot>
          </v-card-text>

          <slot name="bottom-buttons"></slot>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CardHeader from '@/components/cards/CardHeader.vue';

  export default {
    name: "CheckboxTable",
    components: {
      CardHeader,
    },
    props: {
      title: {
        type: String,
        required: false,
        default: "List"
      },
      icon: {
        type: String,
        required: false,
        default: "mdi-assignment"
      },
      data: {
        type: Array,
        required: true,
      },
      columns: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        localTableData: [...this.data],
        selectedItems: [],
      };
    },
    methods: {
      updateSelected(selectedRows) {
        this.selectedItems = selectedRows;
        this.$emit('selected-items', this.selectedItems);
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
